import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("track", {
    isComponent: (el) => {
      if (el.tagName === "main") {
        return {
          type: "track",
        };
      }
    },
    model: {
      defaults: {
        tagName: "main",
        attributes: {
          class: "flex-1 flex items-center justify-center",
        },
        components: html`
          <div class="container mx-auto my-2 md:my-12 px-4">
            <div
              class="flex gap-x-4 justify-left items-center ms-3 md:ms-0 my-4 "
            >
              <p
                class="md:text-primary text-[#535353] text-sm font-bold md:text-xl uppercase"
              >
                HOME &gt; Track
              </p>
            </div>

            <div
              class="flex w-full justify-center text-white items-center flex-col rounded gap-4 md:gap-x-4  px-4  bg-[#2B2828] py-4 "
            >
              <div class="relative">
                <form id="track-form">
                  <p class="md:text-lg font-semibold">
                    Tracking ID/ Order Number*
                  </p>
                  <div class=" w-full   flex gap-x-2">
                    <label>
                      <input
                        type="text"
                        name="search"
                        id="tracking-number"
                        placeholder="Enter your tracking number, (+977)mobile number or reference number"
                        class="outline-none px-4 py-2 w-full rounded bg-white md:w-[650px] text-black "
                      />
                    </label>
                    <button
                      type="submit"
                      class="px-4 py-2 w-24 bg-[#63096B] h-[40px] mb-auto rounded ripple-effect overflow-hidden relative cursor-pointer"
                    >
                      Track
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div
              id="order-details"
              class="hidden md:mt-6 max-w-6xl mx-auto mt-2"
            >
              <div class="flex justify-between text-3xl font-bold my-2">
                <div class="text-lg md:text-2xl">
                  <p id="pickup-branch">Butwal</p>
                </div>
                <div class="text-lg md:text-2xl">---------</div>
                <div class="text-lg md:text-2xl">
                  <p id="destination">Baglung</p>
                </div>
              </div>
              <div
                class="flex justify-between  md:mt-6 mt-2 md:gap-x-6 flex-col md:flex-row gap-y-2"
              >
                <div>
                  <div
                    class="md:text-lg w-full font-semibold whitespace-nowrap"
                  >
                    Order Details
                  </div>
                  <div class="whitespace-nowrap flex flex-col gap-y-2">
                    <p id="waybill">Waybill:</p>
                    <p id="date">Date:</p>
                    <p id="cod">COD: Rs.</p>
                    <p id="weight">Weight:</p>
                    <p id="collected-cod">Collected COD: Rs.</p>
                    <p id="status">Status:</p>
                  </div>
                </div>
                <div>
                  <div class="md:text-lg font-semibold">Sender</div>
                  <div class="flex flex-col gap-y-2">
                    <p id="sender-name" class="capitalize">Name:</p>
                    <p>
                      Phone:
                      <a id="sender-phone" href="#" class="text-gray-500"></a>
                    </p>
                    <p id="sender-address"></p>
                  </div>
                </div>
                <div>
                  <div class="md:text-lg font-semibold">Receiver</div>
                  <div class="flex flex-col gap-y-2">
                    <p id="receiver-name">Name:</p>
                    <p>
                      Phone:
                      <a id="receiver-phone" href="#" class="text-gray-500"></a>
                    </p>
                    <p id="receiver-address"></p>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="delivery-info"
              class="hidden grid  md:grid-cols-2  md:gap-x-6 max-w-6xl mx-auto mt-6 "
            >
              <div id="rider-info">
                <div class="md:text-lg font-semibold">Rider</div>
                <div class="flex flex-col gap-y-2">
                  <p id="rider-name">Name:Test</p>
                  <p>
                    Phone:
                    <a id="rider-phone" href="#" class="text-gray-500"
                      >654646546</a
                    >
                  </p>
                </div>
              </div>
              <div id="pod-info">
                <div class="grid grid-cols-2 gap-x-2">
                  <div class="flex flex-col gap-y-2">
                    <p class="md:text-lg font-semibold">Proof of Delivery</p>
                    <p id="collecter-name">Name:Test</p>
                    <p>
                      Phone:
                      <a id="collecter-phone" href="#" class="text-gray-500"
                        >45564544</a
                      >
                    </p>
                    <p id="collecter-id">ID:54654665446</p>
                  </div>
                  <div class="w-36 h-32">
                    <img
                      id="signature"
                      src=""
                      class="w-full h-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              id="order-tracking"
              class="hidden grid md:grid-cols-2 grid-cols-1 gap-y-2 md:gap-x-6 max-w-6xl mx-auto md:mt-6 mt-2 "
            >
              <div class="text-lg font-bold">
                Order History
                <div
                  id="order-history"
                  class="flex flex-col md:grid mt-6 max-h-[40svh] overflow-y-auto"
                ></div>
              </div>
              <div class="text-lg font-bold">
                Remarks
                <div
                  id="remarks"
                  class="flex flex-col md:grid mt-6 max-h-[40svh] overflow-y-auto"
                ></div>
              </div>
            </div>
          </div>
        `,
        script: function () {
          const form = document.querySelector("form") as HTMLFormElement;
          const urlParams = new URLSearchParams(window.location.search);
          const trackingNumber = urlParams.get("search");
          const trackingInput = document.querySelector(
            "input[name='search']"
          ) as HTMLInputElement;
          if (trackingInput && trackingNumber) {
            trackingInput.value = trackingNumber;
          }

          function updateOrderDetails(data) {
            document.getElementById(
              "waybill"
            ).textContent = `Waybill: ${data.tracking_number}`;
            document.getElementById("cod").textContent = `COD: Rs.${data.cod}`;
            document.getElementById(
              "pickup-branch"
            ).textContent = `${data.pickup_branch}`;
            document.getElementById(
              "destination"
            ).textContent = `${data.destination_branch}`;
            document.getElementById("date").textContent = `Date: ${new Date(
              data.created
            ).toLocaleString()}`;
            document.getElementById(
              "weight"
            ).textContent = `Weight: ${data.weight} Kgs`;
            document.getElementById(
              "collected-cod"
            ).textContent = `Collected COD: Rs.${data.collected_cod}`;
            document.getElementById(
              "status"
            ).textContent = `Status: ${data.status}`;
            document.getElementById(
              "sender-name"
            ).textContent = `Name: ${data.sender.full_name}`;
            document.getElementById(
              "sender-phone"
            ).textContent = `${data.sender.primary_contact}`;
            document.getElementById(
              "sender-address"
            ).textContent = `Location: ${data.sender.address}`;
            document.getElementById(
              "receiver-name"
            ).textContent = `Name: ${data.receiver.full_name}`;
            document.getElementById(
              "receiver-phone"
            ).textContent = `${data.receiver.primary_contact}`;
            document.getElementById(
              "receiver-address"
            ).textContent = `Location: ${data.receiver.address}`;
            document.getElementById("order-details").classList.remove("hidden");
          }
          function updateOrderHistory(historyData) {
            const historyContainer = document.getElementById("order-history");
            historyContainer.innerHTML = "";
            historyData.forEach((item) => {
              const historyItem = document.createElement("div");
              historyItem.classList.add("flex");
              historyItem.innerHTML = `
                <div class="col-start-2 col-end-4  mx-2 relative ">
                  <div class="h-full w-6 flex items-center justify-center">
                    <div
                      class="h-full w-1 bg-green-500 pointer-events-none"
                    ></div>
                  </div>
                  <div
                    class="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-green-500 shadow text-center"
                  >
                    <i class="fas fa-check-circle text-white"></i>
                  </div>
                </div>
                <div
                  class="col-start-4 col-end-12 px-4 py-2 my-2 rounded-xl bg-green-500 text-white  mr-auto w-full"
                >
                  <div class="flex justify-between items-center w-full">
                    <h3 class="font-semibold text-lg  capitalize">
                      ${
                        item.old_data
                          ? `${item.old_data} ➜ ${item.new_data}`
                          : `${item.new_data}`
                      }
                    </h3>
                    <p class="leading-tight text-justify  text-sm">
                      ${new Date(item.created).toLocaleString()}
                    </p>
                  </div>
                  <p>${item.branch.name}</p>
                </div>
              `;
              historyContainer.appendChild(historyItem);
              document
                .getElementById("order-tracking")
                .classList.remove("hidden");
            });
          }

          function updateRemarks(commentsData) {
            const remarksContainer = document.getElementById("remarks");
            remarksContainer.innerHTML = "";
            commentsData.forEach((comment) => {
              const remarkItem = document.createElement("article");
              remarkItem.classList.add(
                "p-4",
                "text-base",
                "bg-white",
                "border-s-2",
                "border-gray-200"
              );

              remarkItem.innerHTML = `
                <footer class="flex justify-between items-center ">
                  <div class="flex items-center">
                    <div class="flex justify-start gap-x-2">
                      <div class="h-8 w-8 md:w-10 md:h-10 rounded-full bg-gray-300 flex items-center justify-center">
                        <p class="text-sm md:text-2xl -mt-1 text-primary">S</p>
                      </div>
                      <p class="inline-flex items-center mr-3 text-sm text-gray-900">Staff</p>
                    </div>
                    <p class="text-sm text-gray-600 dark:text-gray-400">${new Date(
                      comment.created
                    ).toLocaleString()}</p>
                  </div>
                </footer>
                <p class="text-gray-500 dark:text-gray-400 ml-14">${
                  comment.comment
                }</p>
              `;
              remarksContainer.appendChild(remarkItem);
            });
          }
          function updateDeliveryInfo(data) {
            const riderInfo = document.getElementById("rider-info");
            const podInfo = document.getElementById("pod-info");

            if (data.rider && (data.rider.name || data.rider.phone_number)) {
              document.getElementById(
                "rider-name"
              ).textContent = `Name: ${data.rider.name}`;
              const riderPhone = document.getElementById("rider-phone");
              riderPhone.textContent = data.rider.phone_number;
              riderPhone.setAttribute("href", `tel:${data.rider.phone_number}`);
              riderInfo.classList.remove("hidden");
            } else {
              riderInfo.classList.add("hidden");
            }

            const hasPodData =
              data.pod &&
              (data.pod.full_name ||
                data.pod.primary_contact ||
                data.pod.identity_number ||
                data.pod.signature);

            if (hasPodData) {
              document.getElementById("collecter-name").textContent = `Name: ${
                data.pod.full_name || "N/A"
              }`;
              const podPhone = document.getElementById("collecter-phone");
              podPhone.textContent = data.pod.primary_contact || "N/A";
              podPhone.setAttribute(
                "href",
                `tel:${data.pod.primary_contact || "#"}`
              );
              document.getElementById("collecter-id").textContent = `ID: ${
                data.pod.identity_number || "N/A"
              }`;

              const image = document.getElementById(
                "signature"
              ) as HTMLImageElement;
              image.src = data.pod.signature || "";
              podInfo.classList.remove("hidden");
            } else {
              podInfo.classList.add("hidden");
            }

            if (
              (data.rider && (data.rider.name || data.rider.phone_number)) ||
              hasPodData
            ) {
              document
                .getElementById("delivery-info")
                .classList.remove("hidden");
            } else {
              document.getElementById("delivery-info").classList.add("hidden");
            }
          }

          const handleTrack = function (data: any) {
            fetch(
              "https://prodenvservice.careinfosolutions.com/apiservice/track-order/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              }
            )
              .then(function (response) {
                if (!response.ok) {
                  return response.json().then((data) => {
                    showToast(data?.message || "Tracking order failed", "red");
                    document
                      .getElementById("order-details")
                      .classList.add("hidden");
                    document
                      .getElementById("order-tracking")
                      .classList.add("hidden");
                    return Promise.reject("Tracking order failed");
                  });
                }
                return response.json();
              })
              .then(function (result) {
                updateOrderDetails(result.order);
                updateOrderHistory(result.history);
                updateRemarks(result.comments);
                showToast("Success ", "green");
              })
              .catch(function (error) {
                console.error("Error submitting checkout:", error);
              });
          };

          const handleGetDeliveryInfo = function (data: any) {
            fetch(
              "https://prodenvservice.careinfosolutions.com/apiservice/order-rider-info/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              }
            )
              .then(function (response) {
                if (!response.ok) {
                  return response.json().then((data) => {
                    document
                      .getElementById("delivery-info")
                      .classList.add("hidden");
                    return Promise.reject("Tracking order failed");
                  });
                }
                return response.json();
              })
              .then(function (result) {
                updateDeliveryInfo(result);
              })
              .catch(function (error) {
                console.error("Error submitting checkout:", error);
              });
          };

          if (form && trackingNumber) {
            handleTrack({ search: trackingNumber });
            handleGetDeliveryInfo({ search: trackingNumber });
          }

          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(form);
            validator.addField(document.querySelector("#tracking-number"), [
              {
                rule: "required",
                errorMessage: "Tracking number  is required",
              },
            ]);
          };
          const initToastLib = function () {};
          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          form.addEventListener("submit", function (e) {
            e.preventDefault();
            const formData = new FormData(form);
            const data: any = {};
            formData.forEach((value, key) => {
              data[key] = value;
            });
            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              handleTrack(data);
              handleGetDeliveryInfo(data);
            });
          });
          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }
          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
